/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMessageDots = createReactComponent("outline", "message-dots", "IconMessageDots", [["path", { "d": "M12 11v.01", "key": "svg-0" }], ["path", { "d": "M8 11v.01", "key": "svg-1" }], ["path", { "d": "M16 11v.01", "key": "svg-2" }], ["path", { "d": "M18 4a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-5l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3z", "key": "svg-3" }]]);

export { IconMessageDots as default };
//# sourceMappingURL=IconMessageDots.mjs.map
